import React from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Legend,
} from "recharts";

export default function CapitalChart({ days, goal = 1 }) {
  const planKey = goal === 2 ? "plan_2" : "plan_1";
  const currentDay = days.filter((d) => d.status !== "not_started").length;

  const chartData = days.map((d) => ({
    day: d.day,
    plan: d[planKey],
    actual: d.status !== "not_started" || d.day === 1 ? d.closing_balance : null,
  }));

  return (
    <div className="glow-card rounded-2xl p-4 sm:p-6">
      <div className="flex items-center justify-between mb-4">
        <h3 className="font-display font-semibold text-lg">Planowany vs rzeczywisty kapitał</h3>
        <span className="text-xs text-demon-muted font-mono">Cel {goal === 2 ? "$200k" : "$100k"}</span>
      </div>
      <ResponsiveContainer width="100%" height={280}>
        <LineChart data={chartData} margin={{ top: 5, right: 10, left: -10, bottom: 0 }}>
          <CartesianGrid strokeDasharray="3 3" stroke="#271e38" />
          <XAxis dataKey="day" stroke="#94a3b8" fontSize={11} tickLine={false} />
          <YAxis
            stroke="#94a3b8"
            fontSize={11}
            tickLine={false}
            scale="log"
            domain={["auto", "auto"]}
            tickFormatter={(v) => (v >= 1000 ? `${Math.round(v / 1000)}k` : v)}
          />
          <Tooltip
            contentStyle={{
              background: "rgba(12,10,18,0.95)",
              border: "1px solid rgba(168,85,247,0.3)",
              borderRadius: 12,
              color: "#e2e8f0",
            }}
            formatter={(v) => (v == null ? "-" : `$${Number(v).toLocaleString("en-US")}`)}
            labelFormatter={(l) => `Dzień ${l}`}
          />
          <Legend wrapperStyle={{ fontSize: 12 }} />
          <Line
            type="monotone"
            dataKey="plan"
            name="PLAN"
            stroke="#f59e0b"
            strokeWidth={2}
            dot={false}
            strokeDasharray="5 4"
          />
          <Line
            type="monotone"
            dataKey="actual"
            name="RZECZYWISTOŚĆ"
            stroke="#a855f7"
            strokeWidth={2.5}
            dot={false}
            connectNulls
          />
        </LineChart>
      </ResponsiveContainer>
      <div className="text-xs text-demon-muted font-mono mt-2">Ukończone dni: {currentDay} / {days.length}</div>
    </div>
  );
}
